module.exports = __webpack_public_path__ + "static/client24-ac4e2676f37d1a7b6f17787f4fc8e536.png";